export const SETTING_TOPICS = {
  EMAILS: 'emails',
  APPOINTMENTS: 'appointments',
  DOCUMENT_GENERATION: 'document-generation'
}

export const SETTING_PAGES = {
  EMAILS: {
    JUPUS_EMAIL: 'jupus-email',
    TEMPLATES: 'templates',
    DESIGN: 'design',
    SIGNATURES: 'signatures',
    NOTIFICATIONS: 'notifications',
    PLACEHOLDERS: 'placeholders'
  },
  APPOINTMENTS: {
    SETUP: 'setup',
    CALENDAR_LIST: 'calendars',
    CALENDAR_DETAIL: 'calendars',
    SERVICE_LIST: 'services',
    SERVICE_DETAIL: 'services',
    BASE_SETTINGS: 'base-settings',
    LINKS: 'links',
    EMBED: 'embed'
  },
  DOCUMENT_GENERATION: {
    TEMPLATES: 'templates'
  }
}
